/*
Sohel 03/20/2023 2699762545 removed Field Position
Sohel 03/20/2023 2699762545 Letter Field Name Change Style
Sohel 03/22/2023 2698964415 Letter Field Payload Changes
Akhila 05/24/2024 2699762545 role access implemeneted
Ravi 05/31/2023 2699762545 changed delete popup message
Ravi 05/31/2023 2699762545 changed delete popup message
*/
import React, {useState} from 'react';
import {withField} from './withField';
import {Tooltip, IconButton, TextField} from '@material-ui/core';
import {ErrorTooltip} from '../../../../components/Tooltips';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import {DeleteOutlined} from '@material-ui/icons';

function LetterFormatFields(props) {
  const {
    name,
    setFieldValue,
    value: current,
    index,
    values,
    key,
    dmArrayHelpers,
    deletedIds,
    setDeletedIds,
    LetterMainAccess,
    editExisting,
  } = props;
  const [isDelete, setIsDelete] = useState(false);
  const handleConfirmDelete = () => {
    dmArrayHelpers.current.remove(index);
    const ids = [
      ...deletedIds,
      values?.selectedFields[index]?.letterFieldId ?
        values?.selectedFields[index]?.letterFieldId :
        0,
    ];
    setDeletedIds(ids);
    handleClose();
  };
  const handleClose = () => {
    setIsDelete(false);
  };

  return (
    <>
      <tr key={key}>
        <td className="recFormat-col recFormat-center">
          <Tooltip title="Delete">
            <IconButton
              onClick={() => setIsDelete(true)}
              disabled={editExisting && !LetterMainAccess?.edit}
            >
              <DeleteOutlined />
            </IconButton>
          </Tooltip>
        </td>

        <td className="recFormat-col global-field-textfields">{current.repositoryName}</td>
        <td className="recFormat-col global-field-textfields">{current.fieldName}</td>
        <td className="recFormat-col global-field-textfields position-field new-standard-textfields">
          <ErrorTooltip title={''}>
            <TextField
              margin="dense"
              type="text"
              inputProps={{min: 1}}
              variant="outlined"
              placeholder={`Letter Field Name`}
              InputLabelProps={{
                shrink: true,
              }}
              name={name + '.letterFieldName'}
              value={current.letterFieldName}
              // error={currentFieldError("letterFieldName")}
              onChange={(e) => {
                setFieldValue(name + '.letterFieldName', e.target.value);
              }}
            />
          </ErrorTooltip>
        </td>
      </tr>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Field"
        value={`Are you sure you want to delete the ${
          current.fieldName || current.fieldNames
        } Field?`}
        handleSubmit={handleConfirmDelete}
      />
    </>
  );
}

export default withField(LetterFormatFields);
